// PeptideVault v6.5 — Notes tab

// ══════════════════════════════════════════════════════
// RENDER: NOTES TAB
// ══════════════════════════════════════════════════════
function renderNotesTab() {
  const sorted = [...S.notes].sort((a,b) => b.date.localeCompare(a.date))
  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:18px">
      <h2 style="font-size:20px;font-weight:700">Research Notes</h2>
      <div class="spacer"></div>
      <button class="btn btn-primary" onclick="openModal('addNote')">${ICONS.plus} Add Note</button>
    </div>

    ${sorted.length === 0 ? `
    <div class="card">
      <div class="empty-state" style="padding:48px">
        <div class="empty-icon">📝</div>
        <p>No notes yet</p>
        <span>Record observations, side effects, protocol changes, or anything you want to remember</span>
      </div>
    </div>` : sorted.map(note => {
      const linkedPep = note.peptideId ? getPeptide(note.peptideId) : null
      return `
      <div class="note-card">
        <div class="row" style="margin-bottom:6px">
          <div>
            <div class="note-date">${fmt(note.date)}</div>
            <div class="note-title">${esc(note.title)}</div>
          </div>
          <div class="spacer"></div>
          <div class="row" style="gap:4px">
            <button class="btn btn-ghost btn-xs" onclick="openModal('editNote',{noteId:'${note.id}'})">${ICONS.edit}</button>
            <button class="btn btn-danger btn-xs" onclick="deleteNote('${note.id}')">${ICONS.trash}</button>
          </div>
        </div>
        ${linkedPep ? `<span class="badge badge-blue" style="margin-bottom:6px">${esc(linkedPep.name)}</span>` : ''}
        <div style="font-size:13px;color:var(--text2);white-space:pre-wrap;line-height:1.6">${esc(note.body)}</div>
      </div>`
    }).join('')}
  </div>`
}

export {
  renderNotesTab
}
